import { ADD_OVERLAY, CLOSE_OVERLAY, REMOVE_OVERLAY } from '../Actions/Overlay.action';

const DEFAULT_STATE = { 
    activeOverlays: [],
};

export const overlay = (state = DEFAULT_STATE, action) => {
    let activeOverlays = Object.assign([], state.activeOverlays)
    switch (action.type) {
        case ADD_OVERLAY:
            if(activeOverlays.indexOf(action.payload.componentName) == -1) {
                activeOverlays.push({ name: action.payload.componentName, onOverlayClick: action.payload.onOverlayClick })
            }

            return {
                ...state,
                activeOverlays,
            }

        case REMOVE_OVERLAY:
            let index = activeOverlays.findIndex(c => c.name == action.payload.componentName)
            if(index != -1) {
                activeOverlays.splice(index, 1)
            }

            return {
                ...state,
                activeOverlays,
            }

        case CLOSE_OVERLAY:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}